import { useCallback } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { useOktaAuth } from "@okta/okta-react";
import store, { persistor } from "../store";
import { setGlobalLoader } from "../store/globalSlice";
import oktaAuth from "../okta";

const _axios = axios.create();

// Middleware to handle API unauthorized error response.
// It logs user out of the application.(Similar to lout header action)
_axios.interceptors.response.use(
  (response) => {
    if (response.status >= 200 && response.status < 300) {
      return response;
    }
  },
  (error) => {
    if (error.response.status === 401) {
      store.dispatch(setGlobalLoader(true));
      oktaAuth.signOut();
      // Threshold for resetting state values.
      setTimeout(() => {
        persistor.purge();
      }, 30);
    } else {
      return Promise.reject(error);
    }
  }
);

const useRequest = () => {
  const { authState } = useOktaAuth();
  const dispatch = useDispatch();

  // memoized the function, as otherwise if the hook is used inside a useEffect, it will lead to an infinite loop
  const memoizedAxios = useCallback(
    (request) => {
      return _axios({
        ...request,
        headers: {
          ...request.headers,
          Authorization: `Bearer ${authState?.idToken?.idToken}`,
        },
      });
    },
    [dispatch, authState?.idToken?.idToken]
  );
  return {
    requestMaker: memoizedAxios,
  };
};

export default useRequest;
